// extracted by mini-css-extract-plugin
export var searchHeader = "_1u-0";
export var searchHeaderDark = "_1u-1";